<div class="mercury-container">
  @if (isFormEnabled()) {

    @if (isFormLoading()) {
      <div class="spinner-overlay">
        <rds-progress-spinner [label]=FORM_TEXTS.LOADING />
      </div>
    }

    <section class="left-panel">
      @if (formConfigDetails) {
        <h6 class="form-title">{{ FORM_TEXTS.FULFILLMENT_TITLE }}</h6>
      }

      <iframe #iframeRef
              [title]="formConfigDetails?.offeringName
                        ? formConfigDetails.offeringName + ' fulfillment form'
                        : 'Fulfillment form'"
              [srcdoc]="htmlContent()"
              (load)="onIframeLoad()"
              id="content-iframe"
              sandbox="allow-scripts allow-forms allow-same-origin"
              class="form-frame">
      </iframe>

      <div class="submit-container">
        <button rds-primary-button
                size="s"
                faroAction="fulfillment submit"
                (click)="triggerIframeSubmit()"
                [disabled]="isSubmitting()">

          @if (isSubmitting()) {
            <div class="loading-container">
              <rds-progress-spinner class="loading-spinner"></rds-progress-spinner>
              {{ FORM_TEXTS.LOADING }}
            </div>
          } @else {
            {{ BUTTON.SUBMIT }}
          }

        </button>
      </div>

    </section>

    <section class="right-panel">

      <div class="info-container">

        <rds-badge size="m" [label]="'Approved'" type="minimal" color="green"></rds-badge>

        <h1>{{ formConfigDetails?.offeringName }}</h1>
        <p>{{ formConfigDetails?.description }}</p>

      </div>

    </section>

  } @else {

    <!--
      Flag-OFF fallback: rendered behind the error alert so screen readers
      and returning users land on meaningful content (not an empty panel).
      Kept minimal because the alert already carries the primary message.
    -->
    <section class="unavailable-panel" aria-labelledby="form-unavailable-heading">
      <h1 id="form-unavailable-heading">{{ FORM_TEXTS.FORM_NOT_FOUND_TITLE }}</h1>
      <p>{{ FORM_TEXTS.FORM_NOT_FOUND }}</p>
      <a rds-primary-button size="s" [routerLink]="'/focus/my-offerings'">
        {{ BUTTON.BACK_TO_MY_OFFERINGS }}
      </a>
    </section>

  }

</div>
